export const TABS = [
  { to: "/accounting", key: "dashboard", end: true },
  { to: "/accounting/journal", key: "journal" },
  { to: "/accounting/cash", key: "cash" },
  { to: "/accounting/bills", key: "bills" },
  { to: "/accounting/invoices", key: "invoices" },
  { to: "/accounting/payments", key: "payments" },
  { to: "/accounting/supplier-dues", key: "supplierDues" },
  { to: "/accounting/contacts", key: "contacts" },
  { to: "/accounting/staff-payments", key: "staffPay" },
  { to: "/accounting/projects", key: "projects" },
  { to: "/accounting/assets", key: "assets" },
  { to: "/accounting/leases", key: "leases" },
  { to: "/accounting/inventory", key: "inventory" },
  { to: "/accounting/eos", key: "eos" },
  { to: "/accounting/payroll-posting", key: "payrollPost" },
  { to: "/accounting/transactions", key: "transactions" },
  { to: "/accounting/reports", key: "reports" },
  { to: "/accounting/executive", key: "executive" },
  { to: "/accounting/accounts", key: "accounts" },
  { to: "/accounting/periods", key: "periods" },
  { to: "/accounting/trial-balance", key: "trialBalance" },
  { to: "/accounting/perms", key: "perms" },
  { to: "/accounting/audit", key: "audit" },
  { to: "/accounting/settings", key: "settings" },
];
